import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { SidePanel, SidePanelProps } from '@mews/b2b-ui';

export const ModalSidePanel = (props: SidePanelProps) => <SidePanel {...props} portalContainerId={DEFAULT_PORTAL_ID} />;
